import { Injectable, inject } from '@angular/core';
import { defer, map, of, shareReplay, switchMap } from 'rxjs';
import 'tailwindcss/defaultTheme';
import { TAILWIND_THEME } from '../tokens';
import type { Config } from 'tailwindcss';
@Injectable({
  providedIn: 'root',
})
export class TailwindThemeService {
  private _theme$ = defer(() => new Promise<Config>((resolve) => resolve(inject(TAILWIND_THEME)))).pipe(
    switchMap((theme) => of(theme)),
    shareReplay(1),
  );

  breakpoints$ = this._theme$.pipe(
    map((theme) => ({
      sm: parseInt(theme['screens']['sm']),
      md: parseInt(theme['screens']['md']),
      lg: parseInt(theme['screens']['lg']),
      xl: parseInt(theme['screens']['xl']),
    })),
  );
}
